module.exports = __webpack_public_path__ + "img/36.d6c46768.jpg";